import type { ProspectStatus } from "@/lib/types";

export const EMAIL_STAGES = [
  { key: "draft", label: "Draft" },
  { key: "sent", label: "Envoyé" },
  { key: "replied", label: "Répondu" },
] as const;

export interface EmailStage {
  index: number; // 0=draft, 1=sent, 2=replied
  validated: boolean; // l'email a été approuvé au moins une fois (ready/sent/replied,
  // ou terminal bounce/unsubscribed survenu après envoi). false si rejected.
  terminal: boolean; // état terminal négatif (bounce/désinscription)
  terminalLabel: string | null;
}

export function deriveEmailStage(status: ProspectStatus): EmailStage {
  switch (status) {
    case "ready":
      return { index: 0, validated: true, terminal: false, terminalLabel: null };
    case "sent":
      return { index: 1, validated: true, terminal: false, terminalLabel: null };
    case "replied":
      return { index: 2, validated: true, terminal: false, terminalLabel: null };
    case "bounced":
      return { index: 1, validated: true, terminal: true, terminalLabel: "Bounce" };
    case "unsubscribed":
      return { index: 1, validated: true, terminal: true, terminalLabel: "Désabonné" };
    case "rejected":
      return { index: 0, validated: false, terminal: true, terminalLabel: "Rejeté" };
    default:
      return { index: 0, validated: false, terminal: false, terminalLabel: null };
  }
}
